<template>
    <div class="col box-shadow pt-3">
        <div>
            <div class="row justify-content-between">
                <div class="col">
                    Available Pricing
                </div>
                <div class="col row justify-content-end">
                    <div class="mx-4 text-center">
                        <div>UNITS</div>
                        <div class="sub-header">{{ currentAvailability.units }}</div>
                    </div>
                    <div class="mx-4 text-center">
                        <div>AVG Size</div>
                        <div class="sub-header">{{ Math.round(currentAvailability.size) }}</div>
                    </div>
                </div>
            </div>
            <div class="row border-top py-3">
                <div class="col-6 border-right">
                    <div class="title-header">GROSS</div>
                    <div class="row">
                        <div class="col-6 text-center">
                            <div class="title-sub-header">AVG Price</div>
                            <div class="value">${{ currentAvailability.list_price | numFormat }}</div>
                        </div>
                        <div class="col-6 text-center">
                            <div class="title-sub-header">AVG $PSF</div>
                            <div class="value" v-if="currentAvailability.psf == 'NaN'">$0</div>
                            <div class="value" v-else-if="isMarketStrata">${{ currentAvailability.psf | numFormat }}</div>
                            <div class="value" v-else>${{ currentAvailability.psf }}</div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="title-header">NET</div>
                    <div class="row">
                        <div class="col-6 text-center">
                            <div class="title-sub-header">AVG Price</div>
                            <div class="value">${{ currentAvailability.net_price | numFormat }}</div>
                        </div>
                        <div class="col-6 text-center">
                            <div class="title-sub-header">AVG $PSF</div>
                            <div class="value" v-if="currentAvailability.net_psf == 'NaN'">$0</div>
                            <div class="value" v-else-if="isMarketStrata">${{ currentAvailability.net_psf | numFormat }}
                            </div>
                            <div class="value" v-else>${{ currentAvailability.net_psf }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import numFormat from 'vue-filter-number-format';
export default {
    props: {
        isMarketStrata: {
            type: Boolean,
            default: false
        },
        rowData: null
    },
    data: function () {
        return {
        }
    },
    computed: {
        modelRowData() {
            return this.rowData
        },
        currentAvailability() {
            const vm = this
            let unitsWithListPrice = this.rowData.filter(item => item.custom_sold_psf);
            let availability = unitsWithListPrice.reduce((acc, curr) => {
                acc.units++;
                if (curr.mls_list_price && !isNaN(Number(curr.mls_list_price))) {
                    acc.size += Math.round((Number(curr.mls_unit_size)));
                }
                if (curr.mls_list_price && !isNaN(Number(curr.mls_list_price))) {
                    acc.list_price += Math.round((Number(curr.mls_list_price)));
                }
                if (curr.mls_psf && !isNaN(Number(curr.mls_psf))) {
                    acc.psf += (Number(curr.mls_psf) / acc.units);
                }
                if (curr.buyer_incentives && !isNaN(Number(curr.buyer_incentives))) {
                    acc.buyer_incentives += Number(curr.buyer_incentives);
                }
                if (curr.net_price && !isNaN(Number(curr.net_price))) {
                    acc.net_price += Math.round(curr.net_price);
                }
                if (curr.net_psf && !isNaN(Number(curr.net_psf))) {
                    acc.net_psf += Math.round(curr.net_psf);
                }
                return acc;
            }, { units: 0, size: 0, list_price: 0, psf: 0, net_psf: 0, net_price: 0, buyer_incentives: 0 });
            if (unitsWithListPrice.length <= 0) {
                return { units: 0, size: 0, list_price: 0, psf: 0, net_psf: 0, net_price: 0, buyer_incentives: 0 };

            } else {
                availability.size = availability.size / unitsWithListPrice.length;
                availability.list_price = availability.list_price / availability.units;
                availability.buyer_incentives = availability.buyer_incentives / availability.units;
                availability.psf = vm.isMarketStrata ? Math.round(availability.list_price / availability.size) : Number(availability.list_price / availability.size).toFixed(2);
                availability.net_price = availability.list_price - availability.buyer_incentives;
                availability.net_psf = vm.isMarketStrata ? Math.round(availability.net_price / availability.size) : Number(availability.net_price / availability.size).toFixed(2);
            }

            return availability
        }
    },
    methods: {
        isRealValue(value) {
            return !["zero", "", "-", null, 0, undefined, "0", "null"].includes(
                value
            );
        },
    }
}
</script>

<style lang="scss" scoped>
.sub-header {
    font-size: larger;
    font-weight: 600;
    color: #12283F;
}

.title-header {
    font-weight: 500;
    color: #12283F;
    font-size: 26px;
}

.title-sub-header {
    font-size: 20px;
    color: #545454;
    font-weight: 500;
}

.value {
    font-size: 30px;
    font-weight: bold;
    color: #12283F;
}

.box-shadow {
    border-radius: 5px;
}

html.dark .sub-header,
html.dark .title-header,
html.dark .value {
    color: #d6e4f0;
}

html.dark .title-sub-header {
    color: rgba(214, 228, 240, 0.75);
}

html.dark :deep(.border-top),
html.dark :deep(.border-right) {
    border-color: rgba(255, 255, 255, 0.08) !important;
}

@media (max-width: 575.98px) {
    .title-header {
        font-size: 18px;
        line-height: 1.2;
    }

    .title-sub-header {
        font-size: 12px;
    }

    .value {
        font-size: 16px;
        word-break: break-word;
        overflow-wrap: anywhere;
        line-height: 1.2;
    }

    .sub-header {
        font-size: 16px;
    }

    /* Stack AVG Price / AVG $PSF vertically inside GROSS / NET */
    .border-top>.col-6>.row>.col-6 {
        flex: 0 0 100%;
        max-width: 100%;
    }

    .border-top>.col-6>.row>.col-6+.col-6 {
        margin-top: 0.5rem;
    }

    /* Tighten the UNITS / AVG Size header spacing */
    :deep(.mx-4) {
        margin-left: 0.5rem !important;
        margin-right: 0.5rem !important;
    }
}
</style>
